<template>
  <el-container>
    <el-aside style=" width:150px;">
      <el-menu
       
        class="el-menu-vertical-demo"
        @open="handleOpen"
        @close="handleClose"
        background-color="rgb(26,35,45)"
        text-color="#fff"
        active-text-color="#ffd04b"
        unique-opened
      >
      <el-menu-item index="1" @click="goToPage('/index')">
                <i class="el-icon-location"></i>
                <span slot="title">首页</span>
              </el-menu-item>
              <el-menu-item index="2" @click="goToPage('/block')">
                <i class="el-icon-menu"></i>
                <span slot="title">区块</span>
              </el-menu-item>
              <el-menu-item index="3" @click="goToPage('/transaction')">
                <i class="el-icon-document"></i>
                <span slot="title">存证</span>
              </el-menu-item>
              <el-menu-item index="4" @click="goToPage('/address')">
                <i class="el-icon-setting"></i>
                <span slot="title">地址</span>
              </el-menu-item>
			      </el-menu>
    </el-aside>
    
    <!-- 这里可以放置你的主内容区域 -->
    <el-main>
      <!-- 你的主内容 -->
    </el-main>
  </el-container>
</template>

<script>
export default {
  data() {
    return {
      backgroundColor: 'rgb(26, 35, 45)',
      textColor: '#fff',
      activeTextColor: '#ffd04b',
    };
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    handleOpen(key, keyPath) {
      console.log('open', key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log('close', key, keyPath);
    },
  },
};
</script>

<style scoped>
.el-aside {
 overflow: hidden;

}
.el-main {
  padding: 20px;
}
.el-menu {
      border-right: none;
}
.el-menu-item:focus, .el-menu-item:hover {
    outline: 0;
    background-color: black;
}


</style>